import React, { useEffect, useState } from 'react';
import styles from './report.module.css';
import image from '../../../assets/images/trend.png';

export default function StatisticsSection({ translate }) {
    const [isScreenLarge, setIsScreenLarge] = useState(window.innerWidth > 1015);
    const [isCardsVisible, setIsCardsVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const isLarge = window.innerWidth > 1015;
            setIsScreenLarge(isLarge);

            // إذا كانت الشاشة كبيرة، تظهر الكروت دائمًا
            if (isLarge) {
                setIsCardsVisible(true);
            } else {
                setIsCardsVisible(false); // إخفاء الكروت في الوضع الصغير
            }
        };

        handleResize(); // التحقق عند التحميل
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.statistics}>
            <div
                onClick={() => {
                    if (!isScreenLarge) {
                        setIsCardsVisible(!isCardsVisible); // تبديل رؤية الكروت عند الضغط على السهم
                    }
                }}
                className="cursor-pointer d-flex justify-between"
            >
                <p
                    style={{ marginBottom: isCardsVisible || isScreenLarge ? '27px' : '0px' }}
                    className={styles.bigTitle}
                >
                    {translate('statistics')}
                </p>
                {!isScreenLarge && (
                    <i style={{color: '#1C5E91'}} className={`fa ${isCardsVisible ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                )}
            </div>

            {(isScreenLarge || isCardsVisible) && (
                <>
                    <div className={styles.oneStatistics}>
                        <div className="d-flex items-center gap_10">
                            <img src={image} width={'23px'} height={'23px'} />
                            <span className={styles.title}>{translate('total_deposits')}</span>
                        </div>
                        <span className={styles.number}>20008522100</span>
                    </div>
                    <div className={styles.oneStatistics}>
                        <div className="d-flex items-center gap_10">
                            <img src={image} width={'23px'} height={'23px'} />
                            <span className={styles.title}>{translate('total_withdrawals')}</span>
                        </div>
                        <span className={styles.number}>20000</span>
                    </div>
                    <div className={styles.oneStatistics}>
                        <div className="d-flex items-center gap_10">
                            <img src={image} width={'23px'} height={'23px'} />
                            <span className={styles.title}>{translate('total_xpenses')}</span>
                        </div>
                        <span className={styles.number}>20000</span>
                    </div>
                </>
            )}
        </div>
    );
}
